import React from 'react';
// components
import Iconify from '../../../../components-core/Iconify';
// ----------------------------------------------------------------------
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import GroupIcon from '@mui/icons-material/Group';

const navConfig = {
  subheader: 'general',
  items: [
    { title: 'Twoje Dane', path: '/client', icon: <Iconify icon={'carbon:user-avatar-filled-alt'} width={20} height={20} /> },
    // { title: 'Dane dzieci', path: '/client/participants', icon: <Iconify icon={'tabler:mood-kid'} width={20} height={20} /> },
    { title: 'Aktualny Stan Rozliczeń', path: '/client/settlement', icon: <AttachMoneyIcon /> },
    { title: 'Grupy', path: '/client/groups', icon: <GroupIcon /> }
  ],
  paths: [
    '/client',
    // '/client/participants',
    '/client/settlement',
    '/client/groups'
  ]
};

export default navConfig;
